import React from 'react';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  id
}: SectionWrapperProps) {
  return <div id={id} className={`relative ${className}`} data-id="element-256">
      {children}
    </div>;
}